import type { LanguagePack } from './types'

export const te: LanguagePack = {
  navSaved: 'సేవ్ చేసినవి',
  navInfo: 'సమాచారం',
  homeTitle: 'మీ కాగితం ఫోటో తీయండి',
  homeHint: 'అందులో ఏమి రాసి ఉందో, మీరు తర్వాత ఏమి చేయాలో సమ్ఝో చెబుతుంది.',
  takePhoto: 'ఫోటో తీయండి',
  uploadFile: 'ఫోటో లేదా PDF అప్‌లోడ్ చేయండి',
  supportedFiles: 'ఫోటో (JPG, PNG, WEBP) లేదా PDF · 10 MB వరకు',
  chooseLanguage: 'ఏ భాషలో వివరించాలి',
  privacyLine: 'మీ కాగితం ఈ ఫోన్‌లోనే చదవబడుతుంది. మీరు "సేవ్ చేయండి" నొక్కితేనే ఇది సేవ్ అవుతుంది.',

  previewTitle: 'ఫోటో సరిగ్గా ఉందా?',
  rotate: 'తిప్పండి',
  crop: 'కత్తిరించండి',
  cropDone: 'అయిపోయింది',
  retake: 'మళ్ళీ తీయండి',
  readNow: 'చదవండి',
  docLanguageLabel: 'కాగితం ఏ భాషలో రాసి ఉంది?',
  docLanguageHint: 'ఇంగ్లీష్ కూడా ఎప్పుడూ చదవబడుతుంది.',

  stepCheck: 'ఫోటో చెక్ చేస్తున్నాం…',
  stepRead: 'కాగితం చదువుతున్నాం…',
  stepExtract: 'ముఖ్యమైన వివరాలు వెతుకుతున్నాం…',
  stepExplain: 'తెలుగులో వివరిస్తున్నాం…',
  firstTimeNote: 'మొదటిసారి చదివే టూల్ డౌన్‌లోడ్ అవుతుంది, కాబట్టి కొంచెం ఎక్కువ సమయం పడుతుంది.',
  cancel: 'రద్దు చేయండి',

  errBadImage: 'ఫోటో కొంచెం స్పష్టంగా లేదు. దయచేసి ఇంకో స్పష్టమైన ఫోటో తీయండి.',
  errNoText: 'ఈ కాగితంపై రాసిన అక్షరాలు ఏవీ సమ్ఝోకి కనిపించలేదు.',
  errUnclearPart: 'ఈ భాగాన్ని సమ్ఝో సరిగ్గా చదవలేకపోయింది.',
  errUnsupportedLanguage: 'ఈ భాషకు ఇంకా సపోర్ట్ లేదు.',
  errLongDocument: 'ఈ కాగితం చాలా పొడవుగా ఉంది. ముందుగా ముఖ్యమైన పేజీలు ఎంచుకోండి.',
  errFileType: 'దయచేసి ఫోటో (JPG, PNG, WEBP) లేదా PDF ఎంచుకోండి.',
  errFileSize: 'ఈ ఫైల్ 10 MB కంటే పెద్దది. దయచేసి చిన్న ఫైల్ ఎంచుకోండి.',
  errGeneric: 'ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.',
  errOcrDownload: 'చదివే టూల్ డౌన్‌లోడ్ కాలేదు. ఒకసారి ఇంటర్నెట్ ఆన్ చేసి మళ్ళీ ప్రయత్నించండి.',
  warnDark: 'ఫోటో చీకటిగా ఉంది. మంచి వెలుతురులో తీసిన ఫోటో బాగా చదవబడుతుంది.',
  warnBlurry: 'ఫోటో మసకగా ఉంది. ఫోన్‌ను కదలకుండా పట్టుకుని మళ్ళీ తీయండి.',
  warnSmall: 'ఫోటో చాలా చిన్నగా ఉంది. కాగితానికి దగ్గరగా తీయండి.',
  tryAgain: 'మళ్ళీ ప్రయత్నించండి',

  pickPagesHint: (max) => `${max} పేజీల వరకు ఎంచుకోండి.`,
  pageLabel: (n) => `పేజీ ${n}`,
  readSelectedPages: (n) => (n === 1 ? '1 పేజీ చదవండి' : `${n} పేజీలు చదవండి`),

  typeSure: (name) => `ఇది ${name} లాగా ఉంది.`,
  typeMaybe: (name) => `ఇది ${name} కావచ్చు, కానీ సమ్ఝోకి పూర్తిగా ఖచ్చితంగా తెలియదు.`,
  typeUnknown: 'ఇది ఏ రకమైన కాగితమో సమ్ఝోకి పూర్తిగా ఖచ్చితంగా తెలియదు.',
  docTypes: {
    income_certificate: { name: 'ఆదాయ సర్టిఫికెట్', about: 'ప్రభుత్వ రికార్డుల ప్రకారం ఒక వ్యక్తి లేదా కుటుంబం ఆదాయం ఇందులో రాసి ఉంటుంది.' },
    caste_certificate: { name: 'కుల సర్టిఫికెట్', about: 'ఒక వ్యక్తి ఏ కులానికి లేదా వర్గానికి చెందినవారో ఇందులో రాసి ఉంటుంది.' },
    domicile_certificate: { name: 'నివాస సర్టిఫికెట్', about: 'ఒక వ్యక్తి శాశ్వతంగా ఎక్కడ ఉంటారో ఇందులో రాసి ఉంటుంది.' },
    birth_certificate: { name: 'జనన సర్టిఫికెట్ (బర్త్ సర్టిఫికెట్)', about: 'ఇది పుట్టుకకు సంబంధించిన ప్రభుత్వ రికార్డు.' },
    death_certificate: { name: 'మరణ సర్టిఫికెట్ (డెత్ సర్టిఫికెట్)', about: 'ఇది మరణానికి సంబంధించిన ప్రభుత్వ రికార్డు.' },
    electricity_bill: { name: 'కరెంటు బిల్లు', about: 'వాడిన కరెంటు, కట్టాల్సిన డబ్బు ఇందులో ఉంటాయి.' },
    water_bill: { name: 'నీటి బిల్లు', about: 'కట్టాల్సిన నీటి ఛార్జీలు ఇందులో ఉంటాయి.' },
    ration_card: { name: 'రేషన్ కార్డు లేదా రేషన్ నోటీసు', about: 'ఇది ప్రభుత్వ రేషన్ షాపు నుండి రేషన్ తీసుకోవడం గురించి.' },
    aadhaar: { name: 'ఆధార్‌కి సంబంధించిన కాగితం', about: 'ఇది ఆధార్ నంబర్ లేదా ఆధార్ వివరాల గురించి.' },
    pan_card: { name: 'పాన్‌కి సంబంధించిన కాగితం', about: 'ఇది పాన్ (టాక్స్ గుర్తింపు) నంబర్ గురించి.' },
    bank_notice: { name: 'బ్యాంకు ఉత్తరం', about: 'ఇది బ్యాంకు నుండి వచ్చిన ఉత్తరం లేదా నోటీసు.' },
    loan_notice: { name: 'అప్పు (లోన్) నోటీసు', about: 'ఇది ఒక లోన్ లేదా బాకీ ఉన్న డబ్బు గురించి.' },
    income_tax_notice: { name: 'ఇన్‌కమ్ టాక్స్ నోటీసు', about: 'ఇది ఆదాయపు పన్ను శాఖ (ఇన్‌కమ్ టాక్స్ డిపార్ట్‌మెంట్) నుండి వచ్చింది.' },
    pension: { name: 'పెన్షన్ ఉత్తరం', about: 'ఇది పెన్షన్ గురించి.' },
    court_notice: { name: 'కోర్టు లేదా లీగల్ నోటీసు', about: 'ఇది కోర్టు నుండి వచ్చింది, లేదా ఒక చట్టపరమైన విషయం గురించి. దీన్ని తేలికగా తీసుకోకండి.' },
    land_record: { name: 'భూమి రికార్డు', about: 'ఇది భూమి ఎవరిది అనే దాని గురించి, లేదా భూమి వివరాల గురించి.' },
    property_tax: { name: 'ఇంటి పన్ను (ప్రాపర్టీ టాక్స్) బిల్లు', about: 'ఇది ఇల్లు లేదా ఆస్తి మీద పన్ను గురించి.' },
    scholarship: { name: 'స్కాలర్‌షిప్ ఉత్తరం', about: 'ఇది చదువు కోసం వచ్చే స్కాలర్‌షిప్ గురించి.' },
    farmer_scheme: { name: 'రైతు పథకం ఉత్తరం', about: 'ఇది రైతుల కోసం ఒక పథకం లేదా సహాయం గురించి.' },
    school_letter: { name: 'స్కూలు ఉత్తరం', about: 'ఇది స్కూలు నుండి వచ్చింది, లేదా చదువు గురించి.' },
    marksheet: { name: 'మార్కుల షీట్ లేదా రిజల్ట్', about: 'ఇందులో పరీక్ష మార్కులు లేదా రిజల్ట్ ఉంటాయి.' },
    insurance: { name: 'బీమా (ఇన్సూరెన్స్) కాగితం', about: 'ఇది ఒక ఇన్సూరెన్స్ పాలసీ గురించి.' },
    traffic_challan: { name: 'ట్రాఫిక్ చలాన్', about: 'ఇది ట్రాఫిక్ లేదా వాహన నియమానికి సంబంధించిన జరిమానా.' },
    job_notice: { name: 'ఉద్యోగం లేదా పరీక్ష ప్రకటన', about: 'ఇది ప్రభుత్వ ఉద్యోగం, నియామకం లేదా దాని పరీక్ష గురించి.' },
    application_receipt: { name: 'దరఖాస్తు రసీదు', about: 'దరఖాస్తు అందిందని ఇది చూపిస్తుంది.' },
    application_decision: { name: 'దరఖాస్తు గురించి ఉత్తరం', about: 'ఇందులో ఒక దరఖాస్తు గురించి నిర్ణయం లేదా సమాచారం ఉంది.' },
    government_notice: { name: 'ప్రభుత్వ నోటీసు', about: 'ఇది ప్రభుత్వ ఆఫీసు నుండి వచ్చిన నోటీసు లేదా ఆదేశం.' },
    lab_report: { name: 'వైద్య పరీక్షల నివేదిక', about: 'ఇందులో రక్తం లేదా ఇతర వైద్య పరీక్షల ఫలితాలు ఉన్నాయి.' },
    rental_agreement: { name: 'అద్దె ఒప్పందం', about: 'ఇది ఇంటి యజమాని మరియు అద్దెదారు మధ్య ఒప్పందం.' },
    loan_agreement: { name: 'రుణ ఒప్పందం', about: 'ఇందులో రుణ నిబంధనలు ఉన్నాయి: వడ్డీ, EMI మరియు ఛార్జీలు.' },
    contract: { name: 'ఒక ఒప్పందం', about: 'ఇది రెండు పక్షాలూ పాటించాల్సిన నిబంధనలతో కూడిన ఒప్పందం.' },
    unknown: { name: 'కాగితం', about: '' }
  },

  seedhiBaat: 'సులభంగా చెప్పాలంటే',
  docSays: 'కాగితంలో ఉన్నది',
  samjhoSays: 'సమ్ఝో వివరణ',
  unclearText: 'ఈ భాగం స్పష్టంగా లేదు — దయచేసి అసలు కాగితం చూడండి.',

  aboutPerson: (name) => `ఈ కాగితం వీరి గురించి: ${name}.`,
  issuedBy: (authority) => `ఇది ఇక్కడి నుండి వచ్చింది: ${authority}.`,
  status: {
    approved: 'దరఖాస్తు మంజూరు అయింది.',
    rejected: 'దరఖాస్తు తిరస్కరించబడింది (రిజెక్ట్ అయింది).',
    pending: 'దరఖాస్తు ఇంకా పరిశీలనలో ఉంది. ఇంకా నిర్ణయం రాలేదు.',
    cancelled: 'ఇది రద్దు చేయబడింది.'
  },
  dateSentence: {
    deadline: (d) => `చివరి తేదీ: ${d}.`,
    due: (d) => `డబ్బు కట్టడానికి చివరి తేదీ: ${d}.`,
    hearing: (d) => `హాజరు కావడానికి కాగితంలో ఇచ్చిన తేదీ: ${d}.`,
    issue: (d) => `ఇది ${d} న ఇవ్వబడింది.`,
    validity: (d) => `ఇది ${d} వరకు చెల్లుతుంది.`,
    birth: (d) => `రాసిన పుట్టిన తేదీ: ${d}.`,
    other: (d) => `ఒక తేదీ రాసి ఉంది: ${d}.`
  },
  daysLeft: (days) => (days === 1 ? 'ఇంకా 1 రోజు ఉంది.' : `ఇంకా ${days} రోజులు ఉన్నాయి.`),
  dueToday: 'ఈ తేదీ ఈ రోజే.',
  datePassed: 'గమనించండి: ఈ తేదీ ఇప్పటికే దాటిపోయింది.',
  amountSentence: {
    payable: (a) => `కట్టాల్సిన మొత్తం: ${a}.`,
    income: (a) => `రాసిన ఆదాయం: ${a}.`,
    fine: (a) => `రాసిన జరిమానా లేదా ఆలస్య రుసుము: ${a}.`,
    fee: (a) => `రాసిన ఫీజు: ${a}.`,
    sanctioned: (a) => `మంజూరు చేసిన లేదా పంపిన మొత్తం: ${a}.`,
    other: (a) => `ఒక మొత్తం రాసి ఉంది: ${a}.`
  },
  actionsPointer: 'కాగితం మిమ్మల్ని ఏదో చేయమని అడుగుతోంది. కింద "మీరు ఏమి చేయాలి" చూడండి.',
  noActionFound: 'కాగితం మిమ్మల్ని ఏదైనా చేయమని స్పష్టంగా అడగడం లేదు.',
  keepSafe: 'ఈ కాగితాన్ని జాగ్రత్తగా దాచుకోండి.',
  doBefore: (d) => `దీన్ని ${d} తేదీ కంటే ముందు చేయండి.`,
  bringDocs: (list) => `ఈ కాగితాలు సిద్ధంగా ఉంచుకోండి: ${list}.`,
  contactFor: (c) => `ప్రశ్నలు ఉంటే ఇక్కడ అడగండి: ${c}.`,
  warningPointer: 'కాగితంలో ఒక హెచ్చరిక ఉంది. దాన్ని జాగ్రత్తగా చదవండి.',
  rejectedNext: 'ఇది పొరపాటు అని మీకు అనిపిస్తే, ఈ ఉత్తరం పంపిన ఆఫీసులో అడగండి.',
  lowQuality: 'ఫోటో అంత స్పష్టంగా లేదు, కాబట్టి కొన్ని వివరాలు తప్పుగా చదవబడి ఉండవచ్చు. అసలు కాగితంతో సరిచూసుకోండి.',

  cardTodo: 'మీరు ఏమి చేయాలి',
  cardDates: 'ముఖ్యమైన తేదీలు',
  cardAmount: 'మొత్తం',
  cardWhere: 'ఎక్కడికి వెళ్ళాలి',
  cardWarnings: 'జాగ్రత్త',
  cardDocs: 'కావాల్సిన కాగితాలు',
  cardPerson: 'ఎవరి గురించి',
  cardFrom: 'ఎవరు పంపారు',
  cardNumbers: 'దాచుకోవాల్సిన నంబర్లు',
  cardContact: 'సంప్రదించండి',
  refKinds: {
    application: 'దరఖాస్తు నంబర్',
    certificate: 'సర్టిఫికెట్ నంబర్',
    consumer: 'కన్స్యూమర్ నంబర్',
    account: 'ఖాతా నంబర్',
    case: 'కేసు నంబర్',
    reference: 'ఉత్తరం నంబర్',
    registration: 'రిజిస్ట్రేషన్ నంబర్',
    receipt: 'రసీదు నంబర్',
    other: 'నంబర్'
  },
  requiredDocNames: {
    aadhaar: 'ఆధార్ కార్డు',
    pan: 'పాన్ కార్డు',
    ration_card: 'రేషన్ కార్డు',
    voter_id: 'ఓటర్ ఐడీ',
    passbook: 'బ్యాంకు పాస్‌బుక్',
    photo: 'ఫోటో',
    income_certificate: 'ఆదాయ సర్టిఫికెట్',
    caste_certificate: 'కుల సర్టిఫికెట్',
    domicile_certificate: 'నివాస సర్టిఫికెట్',
    birth_certificate: 'జనన సర్టిఫికెట్',
    land_record: 'భూమి రికార్డు',
    electricity_bill: 'కరెంటు బిల్లు',
    address_proof: 'చిరునామా రుజువు',
    id_proof: 'గుర్తింపు రుజువు',
    affidavit: 'అఫిడవిట్',
    application_form: 'దరఖాస్తు ఫారం'
  },

  voiceDownloadNote: 'మొదటిసారి వాయిస్ డౌన్‌లోడ్ అవుతోంది (సుమారు 58 MB). ఆ తర్వాత ఇంటర్నెట్ లేకుండా కూడా పనిచేస్తుంది.',

  listen: 'వినండి',
  pause: 'కాసేపు ఆపండి',
  resume: 'కొనసాగించండి',
  stop: 'ఆపండి',
  noVoice: 'ఈ ఫోన్‌లో తెలుగు వాయిస్ లేదు.',
  noVoiceHint: 'ఫోన్ సెట్టింగ్స్‌లో (Text-to-speech) వాయిస్ జోడించవచ్చు, లేదా వేరే భాషలో వినవచ్చు.',
  listenInHindi: 'హిందీలో వినండి',
  listenInEnglish: 'ఇంగ్లీషులో వినండి',
  noSpeechSupport: 'ఈ బ్రౌజర్‌కి చదివి వినిపించే సౌకర్యం లేదు.',

  disclaimer: 'సమ్ఝో మీ కాగితాన్ని సులభంగా వివరిస్తుంది. ముఖ్యమైన వివరాలను ఎప్పుడూ అసలు కాగితంతో గానీ, దాన్ని ఇచ్చిన ఆఫీసుతో గానీ సరిచూసుకోండి. సమ్ఝో ప్రభుత్వ సేవ కాదు. ఇది న్యాయ సలహా కూడా కాదు.',
  fullText: 'సమ్ఝో ఏమి చదివింది',
  fullTextHint: 'రంగు వేసిన లైన్లు స్పష్టంగా చదవబడలేదు.',
  newDocument: 'కొత్త కాగితం',
  save: 'ఈ ఫోన్‌లో సేవ్ చేయండి',
  saved: 'ఈ ఫోన్‌లో సేవ్ అయింది',
  share: 'షేర్ చేయండి',
  copied: 'కాపీ అయింది',
  translateLines: 'కాగితంలోని ఇంగ్లీష్ లైన్లను తెలుగులో చూపించండి',
  helperMode: 'సహాయక మోడ్',
  helperModeHint: 'ఇతరులకు కాగితాలు చదివి చెప్పేవారి కోసం (CSC, NGO, వాలంటీర్లు). ఇందులో సేవ్ ఆపివేయబడుతుంది, "తదుపరి వ్యక్తి" నొక్కితే అంతా తొలగిపోతుంది.',
  nextPerson: 'తదుపరి వ్యక్తి',
  listenMode: 'వినే మోడ్',
  listenModeHint: 'వివరణ సిద్ధమైన వెంటనే సమ్ఝో దానంతట అదే చదివి వినిపిస్తుంది.',
  settingsTitle: 'సెట్టింగ్‌లు',
  shareVoiceNote: 'వాయిస్ నోట్‌గా పంపండి',
  makingVoiceNote: 'వాయిస్ నోట్ తయారవుతోంది…',
  voiceNoteFailed: 'ఈ ఫోన్‌లో వాయిస్ నోట్ తయారు చేయలేకపోయాం.',
  translateOtherLines: 'కాగితంలోని ఇతర భాషా లైన్లను తెలుగులో చూపించండి',
  translateAiNote: 'ఇంగ్లీష్‌లో లేని లైన్లను ఒక AI సేవ (Groq) అనువదిస్తుంది.',
  translateConsent: 'అనువాదం కోసం ఈ లైన్లు ఇంటర్నెట్ ద్వారా సమ్ఝో సర్వర్‌కి పంపబడతాయి. అక్కడ అవి సేవ్ కావు. ఆధార్, ఫోన్ లాంటి నంబర్లు ముందే తీసేయబడతాయి.',
  translateConfirm: 'సరే, అనువదించండి',
  translating: 'అనువాదం జరుగుతోంది…',
  translateNote: 'మెషిన్ అనువాదం — తప్పులు ఉండవచ్చు.',
  translateFailed: 'ఇప్పుడు అనువాదం అందుబాటులో లేదు.',
  retryRotated: 'ఫోటో తిప్పి మళ్ళీ చదవండి',

  addToCalendar: 'క్యాలెండర్‌లో రిమైండర్ జోడించండి',
  askTitle: 'ఈ పత్రం గురించి అడగండి',
  askHint: 'మీ సొంత మాటల్లో అడగండి. సమ్ఝో మీ పత్రం నుంచి జవాబు ఇస్తుంది — అందులో లేకపోతే, ప్రభుత్వ వెబ్‌సైట్ల నుంచి మాత్రమే.',
  askPlaceholder: 'మీ ప్రశ్నను రాయండి లేదా చెప్పండి…',
  askSend: 'అడుగు',
  askMic: 'మాట్లాడి అడగండి',
  askListening: 'వింటోంది… ఇప్పుడు మాట్లాడండి',
  askWebToggle: 'అవసరమైతే ప్రభుత్వ వెబ్‌సైట్లు కూడా చూడండి',
  askConsent: 'జవాబు ఇవ్వడానికి, ఈ పత్రంలోని రాత మరియు మీ ప్రశ్న ఇంటర్నెట్ ద్వారా సమ్ఝో సర్వర్‌కి మరియు ఒక AI సేవకు (Groq) పంపబడతాయి. ఆధార్, పాన్, ఫోన్ నంబర్, ఈమెయిల్ ముందే తీసేయబడతాయి. ఏదీ సేవ్ కాదు.',
  askOfficialOnly: 'ప్రభుత్వ వెబ్‌సైట్లు మాత్రమే చూడబడతాయి, ఉదాహరణకు:',
  askConsentConfirm: 'సరే, అడుగు',
  askThinkingDoc: 'మీ పత్రాన్ని చదువుతోంది',
  askThinkingWeb: 'ప్రభుత్వ వెబ్‌సైట్లు చూస్తోంది',
  askFromDoc: 'మీ పత్రం నుంచి',
  askFromWeb: 'ప్రభుత్వ వెబ్‌సైట్ నుంచి',
  askNotFound: 'ఇది మీ పత్రంలో గానీ ప్రభుత్వ వెబ్‌సైట్లలో గానీ సమ్ఝోకి దొరకలేదు. ఈ పత్రం పంపిన కార్యాలయాన్ని అడగండి.',
  askUnverified: 'దీన్ని పత్రంలోని ఖచ్చితమైన లైన్‌తో సమ్ఝో సరిపోల్చలేకపోయింది. పత్రం చూసి సరిచూసుకోండి.',
  askSources: 'మూలాలు',
  askOfficial: 'ప్రభుత్వ',
  askFailed: 'ఇప్పుడు జవాబు రాలేదు. మళ్ళీ ప్రయత్నించండి.',
  askBusy: 'ఇప్పుడు చాలా ప్రశ్నలు వస్తున్నాయి. ఒక నిమిషం ఆగి మళ్ళీ అడగండి.',
  askAiNote: 'ఈ జవాబులు AI రాసింది, తప్పులు ఉండవచ్చు. ముఖ్యమైన విషయాలు కార్యాలయంలో నిర్ధారించుకోండి.',
  askTryNext: 'ఇది కూడా అడగవచ్చు:',
  askJump: 'ప్రశ్న అడగండి',
  askSuggest: {
    fillForm: 'ఈ ఫారం ఎలా నింపాలి? ప్రతి గడిని వివరించండి.',
    first: 'నేను ముందుగా ఏం చేయాలి?',
    deadline: 'చివరి తేదీ దాటితే ఏమవుతుంది?',
    pay: 'దీన్ని ఎలా, ఎక్కడ కట్టాలి?',
    papers: 'ఈ పత్రాలు ఎక్కడ దొరుకుతాయి?',
    rejected: 'ఇది ఎందుకు తిరస్కరించబడింది, ఇప్పుడు నేను ఏం చేయవచ్చు?',
    meaning: 'ఈ పత్రాన్ని చాలా సులభమైన మాటల్లో వివరించండి.',
    contact: 'దీని గురించి ఎవరిని సంప్రదించాలి?',
    schemes: 'ఈ పత్రం ప్రకారం నేను ఏ ప్రభుత్వ పథకాలకు అర్హుడిని కావచ్చు?'
  },

  helpTitle: 'సహాయం పొందండి',
  nearbyTitle: 'దగ్గరలోని కార్యాలయం',
  nearbyNote: 'మీ దగ్గరి మ్యాప్ తెరుచుకుంటుంది. మీ లొకేషన్ మ్యాప్‌కి మాత్రమే వెళ్తుంది — సమ్ఝో దాన్ని చూడదు, సేవ్ చేయదు.',
  locating: 'మీ లొకేషన్ వెతుకుతోంది…',
  schemesTitle: 'ప్రభుత్వ పథకాలు',
  schemesText: 'ఈ పత్రం ప్రకారం మీకు ఏ పథకాలు పనికి రావచ్చో సమ్ఝో ప్రభుత్వ పథకాల వెబ్‌సైట్లలో చూడగలదు.',
  schemesButton: 'నాకు పథకాలు వెతుకు',
  legalTitle: 'ఉచిత న్యాయ సహాయం',
  legalText: 'న్యాయ సేవల ప్రాధికార సంస్థ నుంచి మీకు ఉచిత న్యాయవాది దొరకవచ్చు — ఉదాహరణకు మహిళలు, పిల్లలు, SC/ST, కార్మికులు, దివ్యాంగులు, తక్కువ ఆదాయం ఉన్నవారు.',
  legalCall: (n) => `${n}కి కాల్ చేయండి (ఉచితం)`,
  legalNearby: 'దగ్గరలోని న్యాయ సేవల ప్రాధికార సంస్థ',
  legalMore: 'మరింత న్యాయ సహాయం',
  legalAskConsent: 'మీ ప్రశ్న ఇంటర్నెట్ ద్వారా సమ్ఝో సర్వర్‌కి, ఒక AI సేవకు (Groq) పంపబడుతుంది; అవి జవాబును ప్రభుత్వ వెబ్‌సైట్లలో మాత్రమే వెతుకుతాయి. ఆధార్, పాన్, ఫోన్ నంబర్, ఈమెయిల్ ముందే తీసేయబడతాయి. ఏదీ సేవ్ కాదు.',
  navLegal: 'న్యాయ సహాయం'
}
